// import heroCarousel1 from '@/images/1.jpg'
import heroCarousel2 from '@/images/2.jpg'
// import heroCarousel4 from '@/images/4.jpg'

export const POST_DRAW_POLL_DEADLINE_GRACE_MS = 10 * 60 * 1000

export const redWaveNumbers = [
  '01', '02', '07', '08', '12', '13', '18', '19', '23', '24', '29', '30', '34', '35', '40', '45', '46'
]

export const blueWaveNumbers = [
  '03', '04', '09', '10', '14', '15', '20', '25', '26', '31', '36', '37', '41', '42', '47', '48'
]

export const greenWaveNumbers = [
  '05', '06', '11', '16', '17', '21', '22', '27', '28', '32', '33', '38', '39', '43', '44', '49'
]

export const waveTables = {
  red: redWaveNumbers,
  blue: blueWaveNumbers,
  green: greenWaveNumbers
}

export const defaults = {
  promoUrl: 'https://example.com',
  liveNote: '直播搅珠于北京时间 21:32 开始',
  stations: [
    { name: '49 彩票 - 集团站', url: 'https://0049.example' },
    { name: '49 彩票 - 备用线路', url: 'https://bk.example' }
  ],
  liveStreamUrl: ''
}

function sampleDraw(issue, nextIssue) {
  return {
    issue,
    nextIssue,
    nextTime: null,
    drawTimeFormatted: '',
    nextIssueDisplay: '',
    nextDrawDeadlineMs: null,
    mainNumbers: [
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' }
    ],
    special: { value: '', zodiac: '', element: '' }
  }
}

export const heroSlides = [
  // { image: heroCarousel1, alt: '首页轮播图 1' },
  { image: heroCarousel2, alt: '首页轮播图 2' },
  // { image: heroCarousel4, alt: '首页轮播图 3' }
]

const bbsFilesBaseGames = [
   '1x1m.js','33ma.js', 'pt1w.js',  '38sl1.js',
  '3gtx.js', '3zpt.js', '4hzt.js', '6w12m.js', '9x18m.js',
  'agge.js', 'bz3x.js', 'bzb.js', 'cxqd.js', 'dddx.js',
  'ds2x.js', 'ds4w.js', 'dxxx.js', 'js2w.js','dxzt.js', 'fs5w.js',
  'fs6x.js', 'fs8m.js', 'gl9x.js', 'gs7w.js', 'hsds.js',
  'txdx.js', 'sbzt.js', 'rccx.js', 'qqsh.js', '2wt2w.js'
]

// const bbsFilesBackend = [
//   'jxesm.js', '7x14ma.js', '3to.js', '6xzt.js', '4x4m.js',
//   'ds4w.js', 'bzlx.js', '4x8m.js', 'sbzt.js', '18ma.js',
//   'dssx.js', 'sxzt.js', '7we.js'
// ]


const bbsFilesBackend = [
  '6xzt.js',
  'js10m.js',
  '18mzt.js',
  '6wzt.js',
  'qxhx.js',
  '3hzt.js', 
  'ptyx.js', 
  'dszt.js', 
  '4x8m.js',
  'sbzt.js',
  '3gbds.js',
  'yqj.js', 
  'mhs.js',
  'xjtm.js',
  '4tzt.js',
  
  'js1t.js',
  'js2x.js',
  
  'yxym.js',
]


/**
 * 玩法前端配置映射（key = 后端返回的 code）
 * 仅存放有特殊配置的玩法，其他玩法自动使用默认配置
 */
export const gameConfigMap = {
  new_HK6: {
    pictureLotteryType: 3,
    bbsId: 1,
    bbsFiles: bbsFilesBaseGames
  },
  xbc: {
    bbsId: 4
  },
  macau: {
    drawSchedule: 'daily',
    liveStreamUrl: 'https://live-macaujc.com/live/livestream/new.m3u8',
    resultUrl: 'https://macaumarksix.com/api/live2',
    drawPageType: 'MACAU',
    pictureLotteryType: 2,
    drawRequest: {
      url: 'https://macaumarksix.com/api/macaujc2.com',
      method: 'get',
      params: { type: 'MACAU' }
    }
  },
  hk: {
    drawSchedule: 'hk246',
    resultUrl: '/api/hk-lot-draws/getHKLotteryResult',
    drawPageType: 'hk',
    pictureLotteryType: 1,
    drawRequest: {
      url: '/api/hk-lot-draws/getHKLotteryResult',
      method: 'get',
      params: {}
    }
  }
}

/**
 * 固定基础玩法（始终显示，不从后端获取）
 */
export const baseGames = [
  {
    id: 'macau',
    label: '新澳六合彩',
    drawSchedule: 'daily',
    liveStreamUrl: 'https://live-macaujc.com/live/livestream/new.m3u8',
    resultUrl: 'https://macaumarksix.com/api/live2',
    pictureLotteryType: 2,
    bbsId: 1,
    bbsFiles: bbsFilesBaseGames,
    drawRequest: {
      url: 'https://macaumarksix.com/api/macaujc2.com',
      method: 'get',
      params: { type: 'MACAU' }
    },
    drawHour: 21,
    drawMinute: 32,
    draw: sampleDraw(112, 113)
  },
  // {
  //   id: 'hk',
  //   label: '香港六合彩',
  //   drawSchedule: 'hk246',
  //   resultUrl: '/api/hk-lot-draws/getHKLotteryResult',
  //   pictureLotteryType: 1,
  //   drawRequest: {
  //     url: '/api/hk-lot-draws/getHKLotteryResult',
  //     method: 'get',
  //     params: {}
  //   },
  //   draw: sampleDraw(48, 49)
  // }
]

export const GAME_ID_TO_DRAW_TYPE = {
  new_HK6: 'new_HK6',
  xbc: 'xbc',
  macau: 'MACAU',
  hk: 'hk',
  'hk-new': 'new_HK6'
}

export function makeGameFromBackend(item) {
  const cfg = gameConfigMap[item.code] || {}
  return {
    id: item.code,
    lotteryTypeId: item.id,
    label: item.nameCn || item.code,
    drawSchedule: cfg.drawSchedule || 'daily',
    resultUrl: cfg.resultUrl || '/api/live',
    useOpenTimeAsDeadline: cfg.useOpenTimeAsDeadline !== undefined ? cfg.useOpenTimeAsDeadline : true,
    drawPageType: cfg.drawPageType || item.code,
    pictureLotteryType: cfg.pictureLotteryType != null ? cfg.pictureLotteryType : null,
    liveStreamUrl: cfg.liveStreamUrl || '',
    bbsId: cfg.bbsId || 4,
    bbsFiles: cfg.bbsFiles || bbsFilesBackend,
    drawRequest: cfg.drawRequest || {
      url: '/api/live',
      method: 'get',
      params: { code: item.code }
    },
    drawHour: item.drawHour,
    drawMinute: item.drawMinute,
    draw: sampleDraw(0, 0)
  }
}

/**
 * 根据后端玩法列表追加到基础玩法后面
 * @param {Array} backendList - 后端返回的 list
 * @returns {Array} games 数组（baseGames + 后端追加的）
 */
export function buildGames(backendList) {
  const base = JSON.parse(JSON.stringify(baseGames))
  if (!Array.isArray(backendList) || backendList.length === 0) return base
  const existingIds = new Set(base.map(g => g.id))
  for (let i = backendList.length - 1; i >= 0; i--) {
    const item = backendList[i]
    if (!existingIds.has(item.code)) {
      base.splice(1, 0, makeGameFromBackend(item))
      existingIds.add(item.code)
    }
  }
  return base
}
